module.exports = __webpack_public_path__ + "img/advantage1_1@2x.36482b9b.png";